export default __webpack_public_path__ + "static/media/wiserr-macbook.908ebc37.png";